import { render, staticRenderFns } from "./IrisChipCreator.vue?vue&type=template&id=0c7c4690&"
import script from "./IrisChipCreator.vue?vue&type=script&lang=ts&"
export * from "./IrisChipCreator.vue?vue&type=script&lang=ts&"
import style0 from "./IrisChipCreator.vue?vue&type=style&index=0&id=0c7c4690&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports